import { Component, Input } from "@angular/core";

@Component({
  selector: "ui-card-title",
  standalone: false,
  template: `<h2 [id]="owns+'-card-'+cardIndex" class="card_title text-center cc-title" [mktRouterLink]="link" [innerHTML]="title | safeHtml" [attr.aria-label]="title | adaFriendlyName: 'ariaLabel'"></h2>`,
  styles: [`
    ::ng-deep h2.card_title {
      margin: 0;
      margin-bottom: 20px;
      font-family: 'Interstate_Light';
      font-size: 21px !important;
      color: #333333;
      font-weight: 400;
      letter-spacing: 0;
      text-align: center;
      line-height: 27px;
      cursor: pointer;
    }

    ::ng-deep h2.card_title.text-center {
      text-align: center;
    }

    ::ng-deep h2.card_title sup {
      font-size:12px !important;
      line-height: 18px;
    }

    @media only screen and (max-width: 900px) {
      ::ng-deep h2.card_title {
        font-size: 1rem !important;
        line-height: 1.2;
        margin-bottom: 5px;
      }
      ::ng-deep h2.card_title a {
        font-size: 1rem !important;
        font-family: 'Interstate_Light';
        font-weight:100;
        line-height: 18px;
      }
    }
    `,
  ],
})
export class CardTitleComponent {
  @Input() cardIndex:string;
  @Input() title: string;
  @Input() link: string;
  @Input() owns: string ='credit';
}
